<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  /*body{*/
  /*  overflow:auto !important;*/
  /*}*/
#app {
  text-align: center;

}
</style>



// WEBPACK FOOTER //
// src/App.vue